__turbopack_context__.v({
  "tabbed-carousel": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel",
  "tabbed-carousel__button-wrapper": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel__button-wrapper",
  "tabbed-carousel__carousels-wrapper": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel__carousels-wrapper",
  "tabbed-carousel__metadata": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel__metadata",
  "tabbed-carousel__metadata--show": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel__metadata--show",
  "tabbed-carousel__tabs-wrapper": "tabbed-carousel-component-module-scss-module__Bgb6WW__tabbed-carousel__tabs-wrapper",
});
